import React, { useState } from 'react';
import { X, Star, Send, MessageSquare } from 'lucide-react';

const SurveyModal = ({ isOpen, onClose, onSubmit, ticketNumber }) => {
  const [formData, setFormData] = useState({
    rating: 0,
    satisfaction: '',
    feedback: '',
    improvements: '',
    recommend: '',
    email: ''
  });

  const [hoveredStar, setHoveredStar] = useState(0);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleStarClick = (rating) => {
    setFormData(prev => ({
      ...prev,
      rating
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.rating || !formData.satisfaction || !formData.feedback) {
      alert('Mohon lengkapi rating, tingkat kepuasan, dan feedback');
      return;
    }

    // Submit survey data
    onSubmit({
      ...formData,
      ticketNumber,
      submittedAt: new Date().toISOString()
    });

    // Reset form
    setFormData({
      rating: 0,
      satisfaction: '',
      feedback: '',
      improvements: '',
      recommend: '',
      email: ''
    });
  };

  const getRatingText = (rating) => {
    const texts = {
      1: 'Sangat Tidak Puas',
      2: 'Tidak Puas',
      3: 'Cukup',
      4: 'Puas',
      5: 'Sangat Puas'
    };
    return texts[rating] || '';
  };

  if (!isOpen) return null;

  return (
    <div className="survey-modal-overlay">
      <div className="survey-modal">
        <div className="survey-header">
          <div className="survey-header-content">
            <MessageSquare size={24} className="survey-icon" />
            <div>
              <h3>Feedback Layanan Verifikasi</h3>
              <p>Bantu kami meningkatkan kualitas layanan</p>
            </div>
          </div>
          <button onClick={onClose} className="survey-close-btn">
            <X size={20} />
          </button>
        </div>

        <form onSubmit={handleSubmit} className="survey-form">
          {/* Rating Section */}
          <div className="form-group">
            <label className="form-label">
              Berapa rating Anda untuk layanan ini? <span className="required">*</span>
            </label>
            <div className="rating-container">
              <div className="stars-container">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    className={`star-btn ${star <= (hoveredStar || formData.rating) ? 'active' : ''}`}
                    onClick={() => handleStarClick(star)}
                    onMouseEnter={() => setHoveredStar(star)}
                    onMouseLeave={() => setHoveredStar(0)}
                  >
                    <Star size={24} />
                  </button>
                ))}
              </div>
              <div className="rating-text">
                {getRatingText(hoveredStar || formData.rating)}
              </div>
            </div>
          </div>

          {/* Satisfaction Level */}
          <div className="form-group">
            <label className="form-label">
              Bagaimana tingkat kepuasan Anda secara keseluruhan? <span className="required">*</span>
            </label>
            <div className="radio-group">
              {[
                'Sangat Puas',
                'Puas',
                'Cukup Puas',
                'Kurang Puas',
                'Tidak Puas'
              ].map((option) => (
                <label key={option} className="radio-option">
                  <input
                    type="radio"
                    name="satisfaction"
                    value={option}
                    checked={formData.satisfaction === option}
                    onChange={handleInputChange}
                  />
                  <span className="radio-custom"></span>
                  {option}
                </label>
              ))}
            </div>
          </div>

          {/* Feedback */}
          <div className="form-group">
            <label className="form-label" htmlFor="feedback">
              Berikan feedback mengenai proses verifikasi <span className="required">*</span>
            </label>
            <textarea
              id="feedback"
              name="feedback"
              value={formData.feedback}
              onChange={handleInputChange}
              placeholder="Ceritakan pengalaman Anda selama proses verifikasi..."
              rows="4"
              className="form-textarea"
            />
          </div>

          {/* Improvements */}
          <div className="form-group">
            <label className="form-label" htmlFor="improvements">
              Saran perbaikan untuk layanan kami
            </label>
            <textarea
              id="improvements"
              name="improvements"
              value={formData.improvements}
              onChange={handleInputChange}
              placeholder="Apa yang bisa kami tingkatkan dari layanan ini?"
              rows="3"
              className="form-textarea"
            />
          </div>

          {/* Recommendation */}
          <div className="form-group">
            <label className="form-label">
              Apakah Anda akan merekomendasikan layanan ini?
            </label>
            <div className="radio-group horizontal">
              {['Ya', 'Tidak', 'Mungkin'].map((option) => (
                <label key={option} className="radio-option">
                  <input
                    type="radio"
                    name="recommend"
                    value={option}
                    checked={formData.recommend === option}
                    onChange={handleInputChange}
                  />
                  <span className="radio-custom"></span>
                  {option}
                </label>
              ))}
            </div>
          </div>

          {/* Email (Optional) */}
          <div className="form-group">
            <label className="form-label" htmlFor="email">
              Email (opsional - untuk follow up)
            </label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleInputChange}
              placeholder="email@example.com"
              className="form-input"
            />
          </div>

          {/* Submit Button */}
          <div className="form-actions">
            <button type="button" onClick={onClose} className="btn-batal">
              Batal
            </button>
            <button type="submit" className="btn-feed">
              <Send size={16} />
              Kirim Feedback
            </button>
          </div>
        </form>

        {/* Footer */}
        <div className="survey-footer">
          <p>
            <strong>No. Tiket:</strong> {ticketNumber}
          </p>
          <p>Terima kasih atas waktu Anda untuk memberikan feedback!</p>
        </div>
      </div>
    </div>
  );
};

export default SurveyModal;